import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';
  
class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: false, 
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, userNAME:result.user_name, userIMAGE:result.user_image, userMOBILE:result.user_mobile, userVERIFIED:result.user_verified, userEMAIL:result.user_email, activeORDERS:result.active_orders, CUSTOMER_DET:CUSTOMER_DET });
        });
    }

    handleClickModalLogOut = () => {
        $('#ModalLogout').modal('show');
    }

    handleClickLogOut = () => {
        localStorage.removeItem('userData');
        localStorage.removeItem('Verified');
        this.setState({ LoggedOut:true });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }
    
    componentDidMount() {
        var customer = localStorage.getItem('userData');
        this.fetchCustomerProfile('PROFILE',customer);
    }
    
    render() { 

        //console.log(localStorage.getItem('delCity'));
        //console.log(localStorage.getItem('delArea'));

        if(localStorage.getItem('userData')==null)
        {
	        return (<Redirect to={'/home'}/>)
        }

        if(this.state.LoggedOut)
        {
	        return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Profile';0
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="section half mt-2 text-center">
                        <div className="section-title text-center">{this.state.userNAME}</div>
                        <div className="section-title text-center">{this.state.userEMAIL}</div>
                        {this.state.userMOBILE!='' && <div className="section-title text-center">{this.state.userMOBILE}</div>}
                    </div>
                    <div className="section full mt-2 mb-2">
                        <ul className="listview image-listview">    
                            <li> 
                                <Link to="/orders" className="item">
                                    <div className="icon-box">
                                        <ion-icon name="reader-outline"></ion-icon>
                                    </div>
                                    <div>
                                        <div>Recent Orders</div>
                                        {this.state.activeORDERS!='' && <span className="badge badge-primary">{this.state.activeORDERS}</span>}
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to="/addresses" className="item">
                                    <div className="icon-box">
                                        <ion-icon name="location-outline"></ion-icon>
                                    </div>
                                    <div>
                                        <div>Delivery Addresses</div>
                                    </div>
                                </Link>
                            </li>
                            <li> 
                                <Link to="/account_settings" className="item">
                                    <div className="icon-box">
                                        <ion-icon name="cog-outline"></ion-icon>
                                    </div>
                                    <div>
                                        <div>Account Settings</div>
                                    </div>
                                </Link>
                            </li>
                            <li> 
                                <Link to="/change_password" className="item">
                                    <div className="icon-box">
                                        <ion-icon name="git-compare-outline"></ion-icon>
                                    </div>
                                    <div>
                                        <div>Change Password</div>
                                    </div>
                                </Link>
                            </li>
                            {/*<li> 
                                <Link to="/about" className="item">
                                    <div className="icon-box">
                                        <ion-icon name="home-outline"></ion-icon>
                                    </div>
                                    <div>
                                        <div>Get In Touch</div>
                                    </div>
                                </Link>
                            </li>
                            <li> 
                                <Link to="/feedback" className="item">
                                    <div className="icon-box">
                                        <ion-icon name="chatbox-outline"></ion-icon>
                                    </div>
                                    <div>
                                        <div>Report Feedback</div>
                                    </div>
                                </Link>
                            </li>*/}
                            <li> 
                                <Link to="#" className="item" onClick={()=>{this.handleClickModalLogOut()}}>
                                    <div className="icon-box">
                                        <ion-icon name="log-out-outline"></ion-icon>
                                    </div>
                                    <div>
                                        <div>Log Out</div>
                                    </div>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="modal fade dialogbox" id="ModalLogout" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">&nbsp;</h5>
                                </div>
                                <div className="modal-body"> 
                                   You are about to logout. Continue? 
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline"> 
                                        <button type="button" className="btn btn-text-success" data-dismiss="modal" onClick={this.handleClickLogOut}>Yes</button>
                                        <button type="button" className="btn btn-text-danger" data-dismiss="modal">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Profile;


// WEBPACK FOOTER //
// ./src/components/Profile.js